import PersonAddIcon from "@material-ui/icons/PersonAdd"
import StayPrimaryPortraitIcon from "@material-ui/icons/StayPrimaryPortrait"
import ComputerIcon from "@material-ui/icons/Computer"
import EmojiPeopleIcon from "@material-ui/icons/EmojiPeople"
import HourglassFullIcon from "@material-ui/icons/HourglassFull"
import MoneyOffIcon from "@material-ui/icons/MoneyOff"
import FaceIcon from "@material-ui/icons/Face"
import ShowChart from "@material-ui/icons/ShowChart"
import { useQuery } from "@apollo/client"
import { Metrics, METRICS_HISTORY_QUERY, METRICS_QUERY } from "AdminApp"
import LoadingBlanket from "./AdminLoadingBlanket"
import { SortingOptions } from "./UserList"

export const MetricsToolbar: React.FC<{
  onChangeSortBy: (val: SortingOptions) => void
  onToggleChartMode: () => void
  includeAnon: boolean
}> = ({ onChangeSortBy, onToggleChartMode, includeAnon }) => {
  const { data, loading, error } = useQuery(METRICS_QUERY)
  useQuery(METRICS_HISTORY_QUERY)
  const metrics = data?._metrics as Metrics | null

  console.log("metrics", metrics)
  if (!metrics) {
    return <LoadingBlanket error={error?.message} />
  }
  const numUsers = metrics.numUsers
  const numPaidUsers = metrics.numPaidUsers - 1 // exclude jam
  const numAnonUsers = metrics.numAnonUsers
  const numDailyActive = metrics.numDailyActive
  const numWeeklyActive = metrics.numWeeklyActive
  const numInvitesThisWeek = metrics.numInvitesThisWeek
  const numSignupsLastDay = metrics.numSignupsLastDay
  return (
    <div
      style={{
        position: "fixed",
        right: 20,
        top: 20,
        zIndex: 2000,
        display: "flex",
        flexDirection: "row",
        overflow: "scroll",
      }}
    >
      <div
        onClick={() => onToggleChartMode()}
        style={{
          backgroundColor: "white",
          borderRadius: 100,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: 40,
          height: 40,
          marginLeft: 5,
          cursor: "pointer",
        }}
      >
        <ShowChart style={{ color: "black", fontSize: 14 }} />
      </div>
      <div
        onClick={() => onChangeSortBy("numInvites")}
        style={{
          backgroundColor: "#08c1ff",
          borderRadius: 100,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: 40,
          height: 40,
          marginLeft: 5,
          cursor: "pointer",
        }}
      >
        <PersonAddIcon style={{ color: "black", fontSize: 14 }} />
      </div>
      {/* <div
        onClick={() => onChangeSortBy("mobile")}
        style={{
          backgroundColor: "#f7af07",
          borderRadius: 100,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: 40,
          height: 40,
          marginLeft: 5,
          cursor: "pointer",
        }}
      >
        <StayPrimaryPortraitIcon style={{ color: "black", fontSize: 14 }} />
      </div> */}
      {/* <div
        onClick={() => onChangeSortBy("desktop")}
        style={{
          backgroundColor: "#f79307",
          borderRadius: 100,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: 40,
          height: 40,
          marginLeft: 5,
          cursor: "pointer",
        }}
      >
        <ComputerIcon style={{ color: "black", fontSize: 14 }} />
      </div> */}
      <div
        onClick={() => onChangeSortBy("downgraded")}
        style={{
          backgroundColor: "#e64d43",
          borderRadius: 100,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: 40,
          height: 40,
          marginLeft: 5,
          cursor: "pointer",
        }}
      >
        <MoneyOffIcon style={{ color: "black", fontSize: 14 }} />
      </div>
      {/* <div
        onClick={() => onChangeSortBy("lastSeen")}
        style={{
          backgroundColor: "lightblue",
          borderRadius: 100,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: 40,
          height: 40,
          marginLeft: 5,
          cursor: "pointer",
        }}
      >
        <HourglassFullIcon style={{ color: "black", fontSize: 14 }} />
      </div> */}
      <div
        onClick={() => onChangeSortBy("createdAt")}
        style={{
          backgroundColor: "black",
          borderRadius: 100,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: 40,
          minWidth: 40,
          marginLeft: 5,
          cursor: "pointer",
        }}
      >
        <EmojiPeopleIcon style={{ color: "white", fontSize: 14 }} />
        <p style={{ fontSize: 12, color: "white", marginLeft: 2 }}>
          {includeAnon ? numUsers + numAnonUsers : numUsers}
        </p>
      </div>
      <div
        onClick={() => onChangeSortBy("paid")}
        style={{
          backgroundColor: "lightgreen",
          borderRadius: 100,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "row",
          height: 40,
          marginLeft: 5,
          paddingLeft: 10,
          paddingRight: 10,
          cursor: "pointer",
        }}
      >
        <p style={{ fontSize: 12, marginLeft: 10 }}>
          {numPaidUsers} paid users
        </p>
        {/* <p style={{ fontSize: 12, marginLeft: 10 }}> */}
        {/* ignore non-music users */}
        {/* {(100 / ((numUsers - 341) / numPaidUsers)).toFixed(2)}% */}
        {/* </p> */}
        {/* <p style={{ fontSize: 12, marginLeft: 10 }}>${numPaidUsers * 10}/mn</p> */}
        {/* <p style={{ fontSize: 12, marginLeft: 10 }}>${numPaidUsers * 120}/yr</p> */}
        {/* <p style={{ fontSize: 12, marginLeft: 10, marginRight: 10 }}>
          ${numPaidUsers * 1200} valuation
        </p> */}
      </div>
      <div
        onClick={() => onChangeSortBy("lastSeen")}
        style={{
          backgroundColor: "lightblue",
          borderRadius: 100,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "row",
          height: 40,
          marginLeft: 5,
          paddingLeft: 10,
          paddingRight: 10,
          cursor: "pointer",
        }}
      >
        <p style={{ fontSize: 12, marginLeft: 10 }}>
          {numSignupsLastDay} daily signups
        </p>
        <p style={{ fontSize: 12, marginLeft: 10 }}>
          {numDailyActive} daily active
        </p>
        {/* <p style={{ fontSize: 12, marginLeft: 10 }}>
          {numWeeklyActive} weekly active
        </p> */}
        {/* <p style={{ fontSize: 12, marginLeft: 10, marginRight: 10 }}>
          {numInvitesThisWeek} invites last week
        </p> */}
      </div>
    </div>
  )
}
